// StatCard.jsx
import React from 'react';

const StatCard = ({ title, value, icon: Icon, color }) => {
  const colors = {
    indigo: 'bg-gradient-to-br from-indigo-50 to-indigo-100 text-indigo-600',
    slate: 'bg-gradient-to-br from-slate-50 to-slate-100 text-slate-600',
    teal: 'bg-gradient-to-br from-teal-50 to-teal-100 text-teal-600',
    amber: 'bg-gradient-to-br from-amber-50 to-amber-100 text-amber-600'
  };

  return (
    <div className="group bg-white rounded-xl p-4 border border-slate-100 shadow-sm hover:shadow-md transition-all duration-200 hover:-translate-y-0.5">
      <div className="flex items-start justify-between">
        <div>
          <p className="text-2xl font-bold text-slate-800">{value}</p>
          <p className="text-xs text-slate-500 font-medium uppercase tracking-wide mt-1">{title}</p>
        </div>
        <div className={`w-10 h-10 rounded-xl flex items-center justify-center ${colors[color]} group-hover:scale-110 transition-transform duration-200`}>
          <Icon className="w-5 h-5" />
        </div>
      </div>
    </div>
  );
};

export default StatCard;